import React from 'react';

import Header from '../../layout/Header.jsx';
import ListTerms from '../../lists/ListTerms.jsx';

const PageTerms = () => (
  <div>
    <Header>Terms &amp; Conditions</Header>
    <ListTerms />
  </div>
);

export default PageTerms;
